import {Route} from '@angular/router';

import {AuthGuard} from "./../../guards/auth.guard";
import {RoleTypes} from "./../../models/roles";
import {LeadsComponent} from "./leads.component";
import {LeadStatisticsComponent} from "./statistics/lead-statistics.component";
import {LeadListComponent} from "./list/lead-list.component";
import {LeadScheduleListComponent} from "./schedule-list/lead-schedule-list.component";
import {LeadImportComponent} from "./import/lead-import.component";
import {LeadImportQuickComponent} from './import/quick.component';
import {LeadAssignOpenerComponent} from "./assign-opener/lead-assign-opener.component";
import {LeadGlobalSearchComponent} from "./global-search/global-search.component";
import {ImportListComponent} from "./import-list/component";


export const routes:Route[] =
    [
        {
            path: 'leads',
            component: LeadsComponent,
            canActivate: [AuthGuard],
            data: {permissions: ['dashboards.leads.view'] },
            children: [
                {
                    path: '',
                    component: LeadStatisticsComponent,
                },
                {
                    path: 'east-coast',
                    component: LeadListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.view'] },
                },
                {
                    path: 'west-coast',
                    component: LeadListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.view'] },
                },
                {
                    path: 'non-qualified',
                    component: LeadListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.view'] },
                },
                {
                    path: 'removed',
                    component: LeadListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.view'] },
                },
                {
                    path: 'scheduled-callback',
                    component: LeadScheduleListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.view'] },
                },
                {
                    path: 'statistics',
                    component: LeadStatisticsComponent
                },
                {
                    path: 'import',
                    component: LeadImportComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.import'] },
                },/*
                {
                    path: 'import-quick',
                    component: LeadImportQuickComponent
                }, */
                {
                    path: 'assign-opener',
                    component: LeadAssignOpenerComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.assignOpener'] },
                },
                {
                    path: 'global-search',
                    component: LeadGlobalSearchComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['dashboards.fs.view'] },
                },
                {
                    path: 'lead-list',
                    component: ImportListComponent,
                    canActivate: [AuthGuard],
                    data: {permissions: ['leads.import'] },
                }
            ]
        }
    ];


// WEBPACK FOOTER //
// ./src/app/views/leads/leads.routes.ts